import { UPDATE_FORM, RESET_FORM } from "../actions/DoctorForm.action";

const formatUTCDate = (date) => {
  return date.toISOString().split("T")[0];
};

const now = new Date();

const firstDayUTC = new Date(
  Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1)
);
const todayUTC = new Date(
  Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
);

const initialState = {
  start_date: formatUTCDate(firstDayUTC),
  end_date: formatUTCDate(todayUTC),
  client_id: "",
  program_ids: [],
  doctor_ids: [],
};

const DoctorformReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FORM:
      return { ...state, ...action.payload };

    case RESET_FORM:
      return { ...initialState, client_id: state.client_id };

    default:
      return state;
  }
};

export default DoctorformReducer;
